import React, { useEffect, useState } from 'react'
import './loading.scss'

export function Loading() {
    return <div className="loading-holder">
        <div className="loader"></div>
        <p>Please wait..</p>
    </div>
}
